var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPudo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55642 5.44444H10.2231C10.8454 5.44444 11.1565 5.44444 11.3942 5.56555C11.6033 5.67207 11.7732 5.84205 11.8798 6.05112C12.0009 6.2888 12.0009 6.59994 12.0009 7.22222V11M7.55642 11V2.77778C7.55642 2.1555 7.55642 1.84436 7.43532 1.60668C7.32879 1.39761 7.15882 1.22763 6.94975 1.1211C6.71207 1 6.40093 1 5.77865 1H3.77865C3.15637 1 2.84523 1 2.60755 1.1211C2.39848 1.22763 2.2285 1.39761 2.12197 1.60668C2.00087 1.84436 2.00087 2.1555 2.00087 2.77778V11M12.5564 11H1.44531M3.94531 3.22222H5.61198M3.94531 5.44444H5.61198M3.94531 7.66667H5.61198",
    stroke: "#0098A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPudo);
export default __webpack_public_path__ + "53a87b60f7bc8146afd7b496e243f25e.svg";
export { ForwardRef as ReactComponent };